

















import { Component } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { Prop } from "vue/types/options";
import ContentListing from "./ContentListing.vue";
import Vue from "vue";

@Component({
  props: {
    contents: Array as () => Array<Content>,
    vertical: Boolean,
    maxItems: {
      type: Number,
      default: 9999
    },
    detailed: {
      type: Boolean,
      default: true
    }
  },
  components: { ContentListing }
})
export default class ContentList extends Vue {
  [x: string]: any;
}
